import { ChangeDetectorRef, inject } from "@angular/core";

export abstract class TabAccessorInterface
{
    private activeTab!: number;
    private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

    abstract getTabs(): Tab[];
    
    onChangeTab(tabId: number): void
    {
        this.setActiveTab(tabId);
        this.cdr.detectChanges();
    }

    setActiveTab(tabId: number): void
    {
        this.activeTab = tabId;
    }

    getActiveTab(): number
    {
        return this.activeTab;
    }
}

export interface Tab
{
    tabNum: number;
    tabDescription: string;
    show: boolean;
}